function Hero() {
  return (
    <div className="hero">
      <div className="hero-grid">
        <div className='info-grid'>
          <div>
            <div className="hero-info">
              <img src="/Frame 2085663186.png" alt="" className='hero-info-imag' />
              <div className='som'>
                <h6>بيع وشراء العقارات</h6>
                <p>بيع وشراء المنازل والأراضي والفلل والعمارات بأفضل الأسعار.</p>
              </div>
            </div>
            <div className="hero-info">
              <img src="/Frame 2085663187.webp" alt="" className='hero-info-imag' />
              <div className='som'>
                <h6>التسويق العقاري الاحترافي</h6>
                <p>تسويق احترافي يضمن وصول عقارك للفئة المستهدفة بسرعة.</p>
              </div>
            </div>
            <div className="hero-info">
              <img src="/Frame 2085663188.webp" alt="" className='hero-info-imag' />
              <div className='som'>
                <h6>عرض العقار بشكل صحيح</h6>
                <p>إبراز مميزات العقار لجذب المشتري المناسب وتحقيق أفضل قيمة.</p>
              </div>
            </div>
            <div className="hero-info">
              <img src="/Frame 2085663189.webp" alt="" className='hero-info-imag' />
              <div className='som'>
                <h6>الإيجار</h6>
                <p>تأجير شقق وفلل وعقارات جاهزة للسكن أو الاستثمار.</p>
              </div>
            </div>
          </div>
        </div>
        <div className='hero-position'>
          <h2>  أطلس معك من الفكره الي التوقيع</h2>
          <p>أن تكون الخيار الاول في المجال العقاري والمساهمه في تطوير مجتمعات عمرانيه مستدامه تعكس جوده الحياه</p>
          <img src="\image 17.png" alt="hero-image" className='hero-image' />
        </div>

      </div>
    </div>
  );
}

export default Hero;